import React from 'react';
import { Toast, Flex, Box, theme, Link, Text } from '@xometry/xometry_loft';

const iconMapping = {
  success: 'fa-check-circle',
  danger: 'fa-exclamation-triangle',
};

const Notification = (props) => {
  const {
    type,
    text,
    handleClose,
    notificationIndex,
    duration,
    extraOptions = {},
  } = props;
  const iconClass = iconMapping[type] || 'fa-info-circle'; // Default icon if type not found
  const {
    learnMorePath = null,
    hasLearnMoreLink = false,
    hideClose = false,
    hasIcon = false,
  } = extraOptions;

  return (
    <div>
      <Toast
        onClose={() => handleClose(type, text)}
        key={notificationIndex}
        kind={type}
        showDuration={duration && type === 'success' ? duration : undefined}
        isOpen
        hideClose={hideClose}
        hideOnClickOutside={true}
      >
        <Flex alignItems="center" gap={1}>
          {hasIcon && <i className={`fa ${iconClass}`} />}
          <Box marginLeft={theme.space[2]}>
            <Text fontSize={theme.fontSizes[0]}>{text}</Text>
            {hasLearnMoreLink && (
              <Link
                marginLeft={theme.space[2]}
                target="_blank"
                href={learnMorePath}
              >
                Learn more
              </Link>
            )}
          </Box>
        </Flex>
      </Toast>
    </div>
  );
};

export default Notification;
